module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp3_9005.2afffafe.png";